var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center justify-center"},[_c('v-btn',{attrs:{"href":_vm.authUrl,"id":"login_btn","loading":_vm.loading,"color":"secondary"}},[_vm._v(" "+_vm._s(_vm.$t('login'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }